<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="16rem"
      style="width: 80%"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">资源管理详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-row>
        <el-col :span="12">
          <el-form-item label="名称" prop="resourceName">
            <el-input
              v-model="form.resourceName"
              :disabled="!IsEdit"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编号" prop="resourceNo">
            <el-input
              v-model="form.resourceNo"
              :disabled="!IsEdit"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="区域" prop="areaCode">
            <treeselect
              v-model="form.areaCode"
              :options="regionData"
              :disabled="!IsEdit"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地理位置" prop="resourceAddress">
            <el-input
              v-model="form.resourceAddress"
              :disabled="!IsEdit"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="经度" prop="longitude">
            <el-input
              v-model="form.longitude"
              :disabled="!IsEdit"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="纬度" prop="latitude">
            <el-input
              v-model="form.latitude"
              :disabled="!IsEdit"
            ></el-input>
          </el-form-item>
        </el-col>
        <ZjLngLatSelect
          class="newtaskposition"
          :point_lng="form.longitude"
          :point_lat="form.latitude"
          @onGotLngLat="onGotLngLat"
        ></ZjLngLatSelect>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="设备类型" prop="resourceType">
            <el-select
              v-model="form.resourceType"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!IsEdit"
            >
              <el-option
                v-for="item in dict.type.integrate_resource_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人" prop="contactPerson">
            <el-input
              v-model="form.contactPerson"
              :disabled="!IsEdit"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="contactMobile">
            <el-input
              v-model="form.contactMobile"
              :disabled="!IsEdit"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addResourcePoi, updateResourcePoi, getResourcePoiById } from "@/api/src/poisource";
import { listEquipmentAreaTree } from "@/api/src/equipmentArea";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "POIManagerEdit",
  controller: "UI",
  action: "POIManagerEdit",
  dicts: ['integrate_resource_type'],
  components: {
    Treeselect
  },
  data() {
    return {
      form: {
        resourceName: '',
        resourceNo: '',
        areaCode: null,
        resourceAddress: '',
        longitude: '',
        latitude: '',
        resourceType: null,
        contactPerson: '',
        contactMobile: '',
      },
      rules: {
        resourceName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        resourceNo: [
          { required: true, message: "请输入编号", trigger: "blur" },
        ],
        areaCode: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
        resourceType: [
          { required: true, message: "请选择设备类型", trigger: "change" },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactMobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: '联系电话格式不正确', trigger: 'blur' }
        ],
      },
      // 是否可编辑
      IsEdit: false,
      // 区域数据
      regionData: [],
    };
  },
  created: function () {
    this.getAreaTree();
    if (this.$route.query.id) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  methods: {
    // 查询区域树
    getAreaTree(){
      listEquipmentAreaTree().then(response =>{
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.code,
            label: obj.label,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.regionData = response.data.map(obj => mapTree(obj));
      });
    },
    // 选择经纬度
    onGotLngLat(obj) {
      this.form.longitude = obj.lng || 0;
      this.form.latitude = obj.lat || 0;
    },
    // 查询数据
    search() {
      getResourcePoiById(this.$route.query.id).then(response => {
        this.form = response.data;
        this.form.jwD = this.form.longitude + ',' + this.form.latitude;
      });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存按钮
    saveForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            updateResourcePoi(this.form).then(response => {
              this.$message({type: "success", message: "修改成功"});
              this.$router.go(-1);
            });
          } else {
            addResourcePoi(this.form).then(response => {
              this.$message({type: "success", message: "新增成功"});
              this.$router.go(-1);
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
::v-deep .vue-treeselect__control{
  height: 4rem;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__control,
::v-deep .vue-treeselect--open-below,
::v-deep .vue-treeselect__menu{
  border-radius: 0;
}
</style>
